export class RetailRocket
{
    track(callback)
    {
        (window["rrApiOnReady"] = window["rrApiOnReady"] || []).push(function() {
            try{
                callback();
            } catch(e) {
                if (isDevelopment) {
                    console.log(e);
                }
            }
        });
    }

    viewContentProduct(product)
    {
        let callback;
        if (product.is_offers) {
            callback = function() {
                rrApi.groupView(product.offers_id);
            };
        } else {
            callback = function() {
                rrApi.view(product.id);
            };
        }

        this.track(callback);
    }

    /**
     * @param categoryCode
     * @returns {boolean}
     */
    static isCategorySendTrack(categoryCode)
    {
        let excludeCategoriesCode = [
            'podarki',
            'podarki-bossu',
            'podarki-dlya-muzhchin',
            'dlya-kolleg',
            'dlya-podrug',
            'dlya-mamy',
            'dlya-lyubimoy'
        ];

        return (excludeCategoriesCode.indexOf(categoryCode) === -1);
    }

    viewContentCategory(category)
    {
        if (RetailRocket.isCategorySendTrack(category.code)) {
            this.track(function() {
                rrApi.categoryView(category.id);
            });
        }
    }

    subscription(email)
    {
        this.track(function() {
            rrApi.setEmail(email);
        });
    }

    oneClick(productId)
    {
        this.track(function() {
            rrApi.addToBasket(productId);
        });
    }

    addToCart(product)
    {
        this.track(function() {
            rrApi.addToBasket(product.id);
        });
    }

    orderTransaction(order, basket)
    {
        let params = {
            transaction: order.id,
            items: this.formatBasket(basket)
        };
        this.track(function() {
            rrApi.order(params);
        });
    }

    formatBasket(basket)
    {
        return basket.map((basketItem) => {
            return RetailRocket.formatBasketItem(basketItem);
        });
    }

    static formatBasketItem(basketItem)
    {
        return {
            id: basketItem.offer_id || basketItem.id,
            qnt: parseFloat(basketItem.quantity),
            price: parseFloat(basketItem.price)
        };
    }
}


// WEBPACK FOOTER //
// ./modules/tracker/retailrocket.js